import './SocialMedia.scss';
import ButtonGoogle from './ButtonGoogle';
import ButtonFace from './ButtonFace';
import ButtonApple from './ButtonApple';
import { SocialActionEnum } from '../../hooks/ControllerSocialMedia';
import ButtonMicrosoft from './ButtonMicrosoft';

interface SocialMediaProps {
  context?: any;
  action?: SocialActionEnum;
}

export default function SocialMedia({ action }: SocialMediaProps) {
  return (
    <div className="box-social">
      <div className="social-medias">
        <div className="social-button">
          <ButtonApple action={action} />
        </div>
        <div className="social-button">
          <ButtonGoogle action={action} />
        </div>
        <div className="social-button">
          <ButtonFace action={action} />
        </div>
        <div className="social-button">
          <ButtonMicrosoft action={action} />
        </div>
      </div>
    </div>
  );
}
